import React, { useState, useEffect } from "react";
import { TableSearchField } from "CommonComponent";

const DataTableSearch = ({ query, setQuery, filterElement }) => {
  const [term, setTerm] = useState(query.search ?? "");

  useEffect(() => {
    setTerm(query.search ?? "");
  }, [query.search]);

  useEffect(() => {
    const delay = setTimeout(() => {
      setQuery((prev) => {
        const nextSearch = term ?? "";
        if ((prev.search ?? "") === nextSearch) {
          return prev;
        }
        return { ...prev, search: nextSearch, page: 1 };
      });
    }, 300);
    return () => clearTimeout(delay);
    // setQuery identity may change when parent re-renders (controlled tables); only debounce search text.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [term]);

  return (
    <div className="d-flex align-items-center mb-3 justify-content-between flex-wrap gap-2">
      <TableSearchField
        value={term}
        onChange={(e) => setTerm(e.target.value)}
      />
      {filterElement ? <div>{filterElement}</div> : null}
    </div>
  );
};

export default DataTableSearch;
